<template>
	<div class="u-app">
		<div class="van-row-item">
			<van-row>
				<a href="#/newUser/simLogin"> 
					<van-col span="3">
						<img src="../../assets/stage/1.png">
					</van-col>
					<van-col span="19">查询办理</van-col>
					<van-col span="2">
						<img src="../../assets/stage/icon25.png">
					</van-col>
				</a>
			</van-row>
			<van-row>
				<a href="https://work.weixin.qq.com/kfid/kfc936d6fd76f9e8553?enc_scene=ENCGh9rMoMTyL4LpCZxr4rRS9cEQASjTFHye1UzncGz72YL">
					<van-col span="3">
						<img src="../../assets/stage/2.png">
					</van-col>
					<van-col span="19">人工客服</van-col>
					<van-col span="2">
						<img src="../../assets/stage/icon25.png">
					</van-col>
				</a>
			</van-row>
			<van-row>
				<a href="#/user/loginAuth">
					<van-col span="3">
						<img src="../../assets/stage/3.png">
					</van-col>
					<van-col span="19">移动实名链接</van-col>
					<van-col span="2">
						<img src="../../assets/stage/icon25.png">
					</van-col>
				</a>
			</van-row>
			<!-- <van-row>
				<a href="#/user/cmcclog1">
					<van-col span="3">
						<img src="../../assets/stage/4.png">
					</van-col>
					<van-col span="19">移动实名教程</van-col>
					<van-col span="2">
						<img src="../../assets/stage/icon25.png">
					</van-col>
				</a>
			</van-row> -->
			<!-- <van-row>
				<a href="#/user/AppLoad">
					<van-col span="3">
						<img src="../../assets/stage/5.png">
					</van-col>
					<van-col span="19">APP下载</van-col>
					<van-col span="2">
						<img src="../../assets/stage/icon25.png">
					</van-col>
				</a>
			</van-row> -->
			<van-row style="margin-bottom:0;padding-bottom: 0;border:0;" @click="wuliu">
				<van-col span="3">
					<img src="../../assets/stage/6.png">
				</van-col>
				<van-col span="19">物流查询</van-col>
				<van-col span="2">
					<img src="../../assets/stage/icon25.png">
				</van-col>
			</van-row>

		</div>
		<div class="lijBnt" @click="userQuerySIM">立即激活</div>
		<div class="notice">
			<div class="u-border">
				<div class="u-flex">
					<div class="u-icon">
						<img src="../../assets/stage/icon18.png">
					</div>
					<div class="u-notice">通知公告</div>
					<div class="u-icon">
						<img src="../../assets/stage/icon19.png">
					</div>
				</div>
				<div class="u-code">
					温馨提示：卡板必须完成实名认证后 方可正常使用，如有疑问 请联系客服处理。
				</div>
			</div>
		</div>

		<div class="notice">
			<div class="notice">
				<div class="u-border">

					<van-row>
						<van-col span="9">
							<img src="../../assets/stage/icon17.png">
						</van-col>
						<van-col span="15">
							<div class="wsm">扫码关注公众号</div>
							<div class="wsm1">更多优惠信息将会第一时间通知</div>
						</van-col>
					</van-row>
					<div class="w-code">
						<img :src="imgs">
					</div>
				</div>
			</div>
		</div>





		<!-- <div class="notice">
			<div class="u-border">
				<div class="exclusive">专属客服</div>
				<van-row>
					<van-col span="9">
						<img src="../../assets/stage/icon17.png" >
					</van-col>
					<van-col span="15">
						<div class="wsm">微信扫码</div>
						<div class="wsm1">添加您的一对一专属客服</div>
					</van-col>
				</van-row>
				<div class="w-code">
					 <img src="../../assets/kefu/kefu5.jpg" >
				</div>
			</div>
		</div> -->
		<!-- 图片实名认证 -->
		<van-dialog v-model="showimg" title="请扫描下方二维码,点击 查快递 即可" show-cancel-button>
			<img style="width:100%;" src="@/assets/kefu/shunfen.jpg" />
			<p style="text-align:center; color:red">备注: 快递一般两个工作内日发出，若查询不到信息 请您耐心等待</p>
		</van-dialog>
		<van-dialog v-model="guanzhuImg" style="color:red" title="更多优惠活动,请关注公众号" show-cancel-button>
			<img style="width:100%;" src="@/assets/kefu/kefu4.png" />
		</van-dialog>
	</div>
</template>

<script>
import { wxRequest } from "@/api/user.js";
export default {
	data() {
		return {
			imgs: '',
			showimg: false,
			guanzhuImg: false
		}
	},
	created() {
		wxRequest("wxAuth/kefu/urls", {}, "post").then((res) => {
			this.imgs = res.data.data;

		})
	},
	methods: {
		userQuerySIM() {
			this.$router.push({
				path: "/newUser/simLogin",
				query: {
					iccid: this.$store.state.iccid,
				},
			});
		},
		wuliu() {
			this.showimg=true;
			//window.location.href = 'http://jDL.com'
		},
		guanzhu() {
			this.guanzhuImg = true;
		},
	}
}
</script>

<style scoped lang="less">
.u-app {
	height: auto;
	background: #DDDDDD;
	padding: 14px 14px 20px;

	.van-row-item {
		background: #fff;
		padding: 20px 14px 20px 18px;
		border-radius: 10px;

		.van-row {
			padding-bottom: 15px;
			border-bottom: 1px solid #EDEDED;
			margin-bottom: 21px;

			.van-col--3 {
				img {
					width: 27px;
				}
			}

			.van-col--19 {
				font-size: 16px;
				font-family: PingFangSC-Medium, PingFang SC;
				font-weight: 500;
				color: #000000;
				line-height: 24px;
			}

			.van-col--2 {
				text-align: right;

				img {
					width: 9px;
					margin-top: 8px;
				}
			}
		}
	}

	.lijBnt {
		width: 100%;
		height: 40px;
		background: #1989FA;
		color: #fff;
		margin: 20px auto;
		border-radius: 21px;
		text-align: center;
		cursor: pointer;
		font-size: 14px;
		line-height: 40px;
		font-weight: bold;
	}

	.notice {
		margin: 16px auto 28px auto;
		border-radius: 10px;
		padding: 10px;
		background: #fff;
		position: relative;

		.u-border {
			border: 1px dashed #D1A481;
			border-radius: 10px;

			.u-flex {
				display: flex;
				justify-content: center;
				align-items: center;

				.u-icon {
					width: 64px;

					img {
						width: 100%;
						vertical-align: middle;
					}
				}

				.u-notice {
					width: 100px;
					font-size: 20px;
					font-weight: 600;
					color: #A17756;
					text-align: center;
					line-height: 28px;
				}
			}

			.u-code {
				padding: 9px 10px 30px;
				color: #A17756;
				font-size: 18px;
				line-height: 24px;
				font-weight :bold;
			}

			.exclusive {
				font-size: 20px;
				font-weight: 600;
				color: #FFFFFF;
				line-height: 42px;
				position: absolute;
				width: 122px;
				text-align: center;
				height: 42px;
				background: url(../../assets/stage/icon16.png) no-repeat center;
				background-size: 100%;
				top: -12px;
				left: 0;
				right: 0;
				margin: auto;
			}

			.van-row {
				margin-top: 40px;
				margin-bottom: 23px;

				.van-col--9 {
					text-align: right;

					img {
						height: 53px;
					}
				}

				.van-col--15 {
					padding-left: 10px;
					text-align: left;
					height: 52px;
					margin-top: 6px;

					.wsm {
						font-size: 16px;
						font-family: PingFangSC-Medium, PingFang SC;
						font-weight: 500;
						color: #000000;
						line-height: 22px;
					}

					.wsm1 {
						font-size: 12px;
						font-family: PingFangSC-Regular, PingFang SC;
						font-weight: 400;
						color: #999999;
						line-height: 17px;
					}
				}
			}

			.w-code {
				width: 242px;
				height: 242px;
				margin: 23px auto 44px auto;
				background: #D1A481;

				img {
					width: 242px;
				}
			}
		}
	}
}</style>
